// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ow-0";
export var leftAlign = "_ow-4";
export var listItem = "_ow-2";
export var listItemWrapper = "_ow-1";
export var operationText = "_ow-3";